// extracted by mini-css-extract-plugin
module.exports = {"Container":"titleSection_Container__230OS","Title":"titleSection_Title__2CVXp","Text":"titleSection_Text__2xfUG"};